const PREFIX = 'proofToken:';

export function saveProofToken(orderId: string, token: string): void {
  try {
    sessionStorage.setItem(`${PREFIX}${orderId}`, token);
  } catch {
    // sessionStorage를 사용할 수 없는 환경이면 무시한다
  }
}

export function getProofToken(orderId: string): string | null {
  try {
    return sessionStorage.getItem(`${PREFIX}${orderId}`);
  } catch {
    return null;
  }
}

export function clearProofToken(orderId: string): void {
  try {
    sessionStorage.removeItem(`${PREFIX}${orderId}`);
  } catch {
    // ignore
  }
}
